<template>
    <form class="price-filter">
      <div v-for="(item,indx) in items" :key="indx">
        <span class="price-filter__name" v-html="item.TITLE"></span>
        <div class="price-filter__items">
            <div class="price-filter__item" v-for="(value, index) in item.VALUES" :key="index">
              <input
                  class="price-filter__radio"
                  type="radio"
                  :name="item.NAME"
                  :id="item.NAME+'-'+index"
                  :value="value.VALUE"
                  :checked=value.CHECKED
                  @change= changeRadio
              >
              <label class="price-filter__label" :for="item.NAME+'-'+index" v-html="value.LABEL"></label>
            </div>
        </div>
      </div>
    </form>
</template>

<script>
export default {
  name: 'GiftmainFilter',
  props : {
    items : {
      type : Object,
      default : () => ([]),
    },
  },
  data : () => ({
    ajaxProcessed : false,
  }),
  methods : {
    changeRadio (){
      document.location.href = event.target.value;
    }
  },
}
</script>
